
export default function ConnectButton() {
  return null;
}

/* export default function ConnectButton() {
    return <w3m-button />
} */
